/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type AnswerType = typeof AnswerType[keyof typeof AnswerType];


export const AnswerType = {
  two_option: 'two_option',
  three_option: 'three_option',
  upstream: 'upstream',
} as const;
